export default {
    meta: {
        title: '店铺推广',
        isShowNav: true,
    },
};
